/**
 * Base class for all rules.
 */
class Rule {
  type;
  config;
  log = [];
  meta = {};
  #guid;

  comparatorFunctions = {
    "gte": (a, b) => a >= b,
    "gt" : (a, b) => a > b,
    "lte": (a, b) => a <= b,
    "lt" : (a, b) => a < b,
    "eq" : (a, b) => a == b,
    "neq": (a, b) => a != b
  }

  constructor(config = {}) {
    this.config = config;
  }

  get guid() {
    return this.#guid;
  }

  set guid(value) {
    this.#guid = value;
  }
  
  evaluate(data) {
    throw new Error("Method 'evaluate()' must be implemented.");
  }

  explain() {
    console.log(`Explainining rule ${this.type}`);
  }

  hydrateMeta() {
  }

  addLog(result = true, target, actual, comparator = "") {
    this.log.push({ time: Date.now(), type: this.type, result: result ? "✅" : "❌", target, actual, comparator });
  }

  get logPrefix() {
    return `\x1b[30;44m[Rule/${this.type}]`;
  }
}

export default Rule;